var ERROR_ELEMENT_CLASS = 'w-alert-con',
	HIDE_CLASS = 'w-js-hide',
	wizard = {
		_redirectToResultsForAccount: function(id) {
			window.location.href = '/horse-supplement-wizard/recommendations/' + id;
		},
		_showErrorMessage: function() {
			$('.' + ERROR_ELEMENT_CLASS).removeClass(HIDE_CLASS);
		},
		_hideErrorMessage: function() {
			$('.' + ERROR_ELEMENT_CLASS).addClass(HIDE_CLASS);
		},
		_getRecipientAccountId: function() {
			return $('#horse_name_sel_results').val();
		},
		_handleViewResultsClick: function() {
			var id = this._getRecipientAccountId();

			if (id) {
				this._redirectToResultsForAccount(id);
			} else {
				this._showErrorMessage();
			}
		},
		init: function() {
			$('.viewResults').on('click', this._handleViewResultsClick.bind(this));
			$('#horse_name_sel_results').on('change', this._hideErrorMessage);
		}
	};

export default wizard;
